"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _providerEvents = _interopRequireDefault(require("wix-art-store-3rd-party/dist/src/sdk/providerEvents"));
var _react = _interopRequireWildcard(require("react"));
var _consts = require("../consts");
var _ProviderIntent = _interopRequireDefault(require("../components/ProviderIntent"));
var _WixSDKProviderApi = _interopRequireDefault(require("../components/WixSDKProviderApi"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var BannerIntent = exports["default"] = /*#__PURE__*/function (_Component) {
  _inheritsLoose(BannerIntent, _Component);
  function BannerIntent() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = BannerIntent.prototype;
  _proto.onMessageReceived = function onMessageReceived(type, payload) {
    switch (type) {
      case _providerEvents["default"].setHeight:
        this.props.enableStoreBanner(payload.height && payload.height > 0);
        break;
      default:
        break;
    }
  };
  _proto.render = function render() {
    var _this = this;
    var _this$props = this.props,
      connectedProviders = _this$props.connectedProviders,
      wixSdk = _this$props.wixSdk,
      styleParams = _this$props.styleParams,
      galleryId = _this$props.galleryId;
    if (styleParams && connectedProviders) {
      return /*#__PURE__*/_react["default"].createElement(_ProviderIntent["default"], {
        api: new _WixSDKProviderApi["default"](wixSdk),
        intent: _consts.providerIntents.banner,
        connectedProviders: connectedProviders,
        additionalParams: {
          galleryId: galleryId
        },
        onMessageReceived: function onMessageReceived(type, payload, resolve, reject) {
          return _this.onMessageReceived(type, payload, resolve, reject);
        },
        styleParams: styleParams
      });
    }
    return null;
  };
  return BannerIntent;
}(_react.Component);